export enum PromoOptionCategoryEnum {
  BANNER = 1,
  LOGO = 2,
  LINKS = 3,
}
